<!-- // ng-init:
socailLink('8,9,10,11,12') -->

<section class="service-help clearfix footer_{{ is_front_logged }}">
  <div class="container">
    <div class="row clearfix">
      <div class="col-sm-12 col-md-12 clearfix">
        <ul>
          <li><a href="mailto:Service@dentalchat.com" target="_top"> Need Help? </a></li>
          <li>
            <a href="mailto:Service@dentalchat.com" target="_top"> Service&#64;dentalchat.com </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>

<footer class="" id="myFooter">
  <div class="footer_top" *ngIf="!hideFooter">
    <div class="container">
      <div class="row clearfix">
        <div class="col-md-3 col-sm-6 col-xs-12 clearfix footer-block">
          <h4>Dental Chat</h4>
          <ul class="link-ft">
            <li><a routerLink="/">Home</a></li>
            <li><a routerLink="/about">About us</a></li>
            <li><a routerLink="/sitemap">Sitemap</a></li>

            <li *ngIf="!is_front_logged">
              <a href="https://blog.dentalchat.com" target="_blank" rel="noreferrer">Blog</a>
            </li>
            <li *ngIf="is_front_logged == 1">
              <a
                href="https://blog.dentalchat.com/server/blog/{{ logged_user_email }}"
                target="_blank"
                rel="noreferrer"
                >Blog</a
              >
            </li>
            <li><a routerLink="/marketplace/listing">Marketplace</a></li>
            <li *ngIf="is_front_logged == 2 || is_front_logged == 3">
              <a
                href="https://blog.dentalchat.com/server/blog/{{ logged_user_email }}"
                target="_blank"
                rel="noreferrer"
                >Blog</a
              >
            </li>

            <li><a routerLink="/contact">Contact</a></li>
            <li><a routerLink="/faq">FAQ</a></li>

            <li *ngIf="!is_front_logged">
              <a href="https://blog.dentalchat.com/my-story" target="_blank" rel="noreferrer"
                >Share your dental story</a
              >
            </li>
            <li *ngIf="is_front_logged == 1">
              <a
                href="https://blog.dentalchat.com/server/mystory/{{ logged_user_email }}"
                target="_blank"
                rel="noreferrer"
                >Share your dental story</a
              >
            </li>
            <li *ngIf="is_front_logged == 2 || is_front_logged == 3">
              <a
                href="https://blog.dentalchat.com/server/mystory/{{ logged_user_email }}"
                target="_blank"
                rel="noreferrer"
                >Share your dental story</a
              >
            </li>
            <li><a routerLink="/contact">Partner with us</a></li>
            <li>
              <a routerLink="/top-dental-questions-get-answers"
                >Top Dental Questions Answered By Local Dentist</a
              >
            </li>
          </ul>
          <div class="clearfix"></div>
        </div>
        <!--end col-->

        <div class="col-md-3 col-sm-6 col-xs-12 clearfix footer-block">
          <h4>Common Dental Problems</h4>

          <ul class="link-ft">
            <li>
              <a
                target="_blank"
                href="/bad-breath-treatment-halitosis-question-chat"
                rel="noreferrer"
                >Bad breath / halitosis</a
              >
            </li>
            <li>
              <a
                target="_blank"
                href="/best-dental-implant-information-best-dental-implants-info-online"
                rel="noreferrer"
                >Best dental implants</a
              >
            </li>
            <li>
              <a
                target="_blank"
                href="/local-ortho-braces-chat-local-orthodontist-blog-online-invisalign-chat"
                rel="noreferrer"
                >Braces, Orthodontics & Invisalign</a
              >
            </li>
            <li>
              <a
                target="_blank"
                href="/broken-filling-blog-and-composite-fillings-chat"
                rel="noreferrer"
                >Broken filling</a
              >
            </li>
            <li>
              <a
                target="_blank"
                href="/local-childrens-dental-care-chat-kids-dentistry-blog"
                rel="noreferrer"
                >Children's dental care</a
              >
            </li>
            <li [hidden]="!showLink1">
              <a
                target="_blank"
                href="/broken-tooth-bonding-chatting-tooth-composite-filling-chat"
                rel="noreferrer"
                >Composite fillings</a
              >
            </li>
            <li [hidden]="!showLink1">
              <a target="_blank" href="/dental-bridge">Dental bridge</a>
            </li>
            <li [hidden]="!showLink1">
              <a target="_blank" href="/toothache-blog-tooth-pain-chat"
                >Dental caries / tooth decay</a
              >
            </li>
            <li [hidden]="!showLink1">
              <a target="_blank" href="/dental-crown-chat-dental-crowns-blog">Dental crowns</a>
            </li>
            <li [hidden]="!showLink1">
              <a target="_blank" href="/dental-implant-failure-dental-implants-information"
                >Dental implant information</a
              >
            </li>
            <li [hidden]="!showLink1">
              <a target="_blank" href="/dental-veneers-info-dental-veneer-chat">Dental veneers</a>
            </li>
            <li [hidden]="!showLink1">
              <a
                target="_blank"
                href="/broken-denture-teeth-questions-and-denture-repair-question-chat"
                >Dentures / denture repair</a
              >
            </li>
            <li [hidden]="!showLink1">
              <a target="_blank" href="/dental-dry-socket-problems-after-tooth-extraction-chat"
                >Dry socket problem</a
              >
            </li>
            <li [hidden]="!showLink1">
              <a target="_blank" href="/teeth-grinding-problem-and-bruxism-chat"
                >Grinding teeth / bruxism</a
              >
            </li>

            <li [hidden]="!showLink1">
              <a target="_blank" href="/gingivitis-chat-online-periodontal-gum-disease-blog"
                >Gingivitis / periodontal gum disease</a
              >
            </li>
            <li [hidden]="!showLink1">
              <a
                target="_blank"
                href="/local-periodontal-teledentistry-consult-gum-disease-blog-online"
                >Gum Disease Information & Treatment</a
              >
            </li>
            <li [hidden]="!showLink1">
              <a target="_blank" href="/loose-crowns-chat-crown-fell-out-blog">Loose crowns</a>
            </li>
            <li [hidden]="!showLink1">
              <a target="_blank" href="/oral-cancer-treatment-chat-mouth-cancer-blog"
                >Oral cancer / mouth cancer</a
              >
            </li>
            <li [hidden]="!showLink1">
              <a target="_blank" href="/getting-braces-orthodontist-treatment-info"
                >Orthodontics / getting braces</a
              >
            </li>
            <li [hidden]="!showLink1">
              <a target="_blank" href="/bleeding-gum-problem">Painful gums</a>
            </li>
            <li [hidden]="!showLink1">
              <a target="_blank" href="/root-canal-chat-info-and-root-canals-blog">Root canal</a>
            </li>
            <li [hidden]="!showLink1">
              <a target="_blank" href="/snoring-treatment-blog-online-sleep-chatting-sleeping-chat"
                >Sleep apnea / snoring</a
              >
            </li>
            <li [hidden]="!showLink1">
              <a target="_blank" href="/tmd-info-blog-tmj-chat-information-online"
                >TMD / TMJ information</a
              >
            </li>
            <li [hidden]="!showLink1">
              <a target="_blank" href="/teeth-sensitivity-chat-tooth-sensitivty-blog"
                >Teeth sensitivity / sensitive tooth</a
              >
            </li>
            <li [hidden]="!showLink1">
              <a
                target="_blank"
                href="/local-teeth-whitening-chat-online-tooth-whitening-treatment-information"
                >Teeth whitening</a
              >
            </li>
            <li [hidden]="!showLink1">
              <a target="_blank" href="/tooth-abscess-problem-question">Tooth abscess</a>
            </li>
            <li [hidden]="!showLink1">
              <a target="_blank" href="/tooth-knocked-out-by-accident-avulsed-tooth-problem-chat"
                >Tooth loss / avulsion</a
              >
            </li>
            <li [hidden]="!showLink1">
              <a target="_blank" href="/tooth-pain-chatting-and-tooth-decay-chat"
                >Tooth pain / toothache</a
              >
            </li>
            <li [hidden]="!showLink1">
              <a target="_blank" href="/wisdom-teeth-pain">Wisdom tooth pain</a>
            </li>

            <!--
              <li [hidden]="!(showLink1)"><a routerLink="/local-snoring-blog-sleep-apnea-chat-online">Snoring / Sleep Apnea</a></li> -->

            <li class="viewmore">
              <a (click)="showHideLinks(1)"
                ><span [hidden]="showLink1">+ More</span
                ><span [hidden]="!showLink1">- Less</span></a
              >
            </li>
          </ul>
        </div>
        <!--end col-->

        <div class="col-md-3 col-sm-6 col-xs-12 clearfix footer-block">
          <h4>Dental Specialties</h4>

          <ul class="link-ft">
            <li><a target="_blank" href="/general-dentistry">General Dentistry</a></li>
            <li>
              <a target="_blank" href="/cosmetic-dentistry-procedures-and-cosmetic-dentist-chat"
                >Cosmetic Dentistry</a
              >
            </li>
            <li>
              <a
                target="_blank"
                href="/local-dental-implants-blog-and-dental-implant-placement-discussion"
                >Dental Implants</a
              >
            </li>
            <li>
              <a target="_blank" href="/dental-public-health-care-chatting-online"
                >Dental Public Health</a
              >
            </li>
            <li>
              <a target="_blank" href="/dental-specialties-chat-dentistry-information-online"
                >Dental Specialists</a
              >
            </li>
            <li [hidden]="!showLink2">
              <a target="_blank" href="/endodontics-chatting-and-local-endodontist-chat"
                >Endodontists</a
              >
            </li>
            <li [hidden]="!showLink2">
              <a target="_blank" href="/holistic-dentistry-organic-dental-care"
                >Holistic Dentistry</a
              >
            </li>
            <li [hidden]="!showLink2">
              <a target="_blank" href="/oral-surgery-information-and-oral-surgeon-chat"
                >Oral Surgeons</a
              >
            </li>
            <li [hidden]="!showLink2">
              <a target="_blank" href="/orthodontics-blog-local-orthodontist-dental-specialty-blog"
                >Orthodontists</a
              >
            </li>
            <li [hidden]="!showLink2">
              <a target="_blank" href="/pediatric-dentistry-chat-and-pediatrics-chatting-online"
                >Pediatric Dentistry</a
              >
            </li>
            <li [hidden]="!showLink2">
              <a target="_blank" href="/online-periodontics-discussion-and-local-periodontist-chat"
                >Periodontists</a
              >
            </li>
            <li [hidden]="!showLink2">
              <a target="_blank" href="/prosthodontist-information-and-prosthodontics-chat"
                >Prosthodontists</a
              >
            </li>
            <li class="viewmore">
              <a (click)="showHideLinks(2)"
                ><span [hidden]="showLink2">+ More</span
                ><span [hidden]="!showLink2">- Less</span></a
              >
            </li>
          </ul>
        </div>
        <!--end col-->

        <div class="col-md-3 col-sm-6 col-xs-12 clearfix footer-block">
          <h4>Are you a top Dentist ?</h4>

          <div class="footer-block-cnt" style="cursor: pointer">
            <a (click)="redirectTo('/dentist/signup')" class="ft-btn">Join DentalChat</a>
          </div>

          <h4>Have a Dental Question ?</h4>

          <div class="footer-block-cnt" style="cursor: pointer">
            <a *ngIf="is_front_logged == 3" (click)="redirectTo('/patient/messages')" class="ft-btn"
              >Chat with a Patient or Dentist</a
            >
            <a *ngIf="is_front_logged == 2" (click)="redirectTo('/patient/messages')" class="ft-btn"
              >Chat with a Dentist</a
            >
            <a *ngIf="is_front_logged == 1" (click)="redirectTo('/dentist/messages')" class="ft-btn"
              >Chat with a Patient</a
            >
            <a
              *ngIf="is_front_logged == 0 || !is_front_logged"
              (click)="redirectTo('/patient/login')"
              class="ft-btn"
              >Chat with a Dentist</a
            >
          </div>
        </div>
        <!--end col-->
      </div>
    </div>
  </div>

  <div class="footer_mid" *ngIf="!hideFooter">
    <div class="container">
      <h4>Dental Information & Dental Resources</h4>

      <div class="row">
        <div class="col-md-4 col-sm-4 col-xs-12">
          <ul class="link-ft">
            <li>
              <a target="_blank" href="dental-specialties-chat-dental-specialty-discussion-online"
                >Dental Specialties</a
              >
            </li>
            <li>
              <a target="_blank" href="cosmetic-dentistry-procedures-and-cosmetic-dentist-chat"
                >Cosmetic Dentistry Procedures</a
              >
            </li>
            <li>
              <a target="_blank" href="dental-pain-from-sensitive-teeth"
                >Dental Pain from Teeth Sensitivity</a
              >
            </li>
            <li>
              <a
                target="_blank"
                href="oral-pathology-questions-and-oral-and-maxillofacial-chat-online"
                >oral and maxillofacial pathology/ oral surgery</a
              >
            </li>
            <li>
              <a target="_blank" href="emergency-dental-care-question"
                >Emergency Dental Care Question / Ask a Local Dentist</a
              >
            </li>

            <!---------------------------------- +32 more new Rahul ----------------------------------->

            <li [hidden]="!showLink3">
              <a
                target="_blank"
                href="emergency-dentist-questions-and-local-dental-question-blog-online"
                >emergency dentist questions, dental question blog online</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a target="_blank" href="local-dentists-communication"
                >Local Dentists Communications</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a
                target="_blank"
                href="needing-a-tooth-filling-composite-bonding-fillings-questions-chat"
                >Needing a Tooth Filling? Composite Bonding Fillings Questions Chat</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a target="_blank" href="why-dental-implants-sometimes-fail-dental-implant-blog"
                >Why Dental Implants sometimes fail? Dental Implant Blog</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a target="_blank" href="teeth-are-sensitive-blog-tooth-sensitivity-chat"
                >Teeth are sensitive blog, tooth sensitivity chat</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a
                target="_blank"
                href="wisdom-tooth-extraction-question-info-wisdom-teeth-chat-online"
                >Wisdom tooth information, third molars discussion</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a
                target="_blank"
                href="pediatric-dental-care-chat-childrens-teeth-development-info-question"
                >Pediatric Dental Care, Children's Teeth Development</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a
                target="_blank"
                href="local-tooth-loss-blog-online-best-dental-bridges-chat-local-dental-implant-blogging"
                >Tooth loss, dental bridges and dental implants</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a target="_blank" href="local-dental-problems-dentist-treatment-solution-chats"
                >Local Dental Problems & Dentist Treatment solution chats</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a
                target="_blank"
                href="best-tooth-pain-questions-blog-local-teeth-pain-question-blogging"
                >Best tooth pain questions</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a target="_blank" href="best-dentist-consult-local-urgent-dental-care-questions"
                >Best Dentist Consult, Local Urgent Dental Care Questions</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a
                target="_blank"
                href="finding-local-emergency-dentists-best-local-dentists-directory-guide"
                >Finding local emergency dentists, best local dentists directory</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a
                target="_blank"
                href="how-to-find-the-best-local-dentists-best-dental-office-directory-search-chat"
                >How to Find the Best Local Dentists, Best Dental Office Directory Search Chat</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a
                target="_blank"
                href="getting-a-tooth-extracted-tooth-extraction-after-care-question"
                >Getting a Tooth Extracted? Tooth Extraction After Care Question</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a
                target="_blank"
                href="new-implant-denture-blog-full-dentures-chat-partial-denture-blogging"
                >New Implant Denture Blog, Full Dentures Chat, Partial Denture Blogging</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a
                target="_blank"
                href="immediate-dental-implant-placement-after-extracting-a-tooth-chat"
                >Immediate Dental Implant Placement After Extracting a Tooth</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a target="_blank" href="online-dental-question-discussion-about-tooth-problems"
                >Tooth Problems Discussion</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a target="_blank" href="local-dentist-chat-bot-messenger-on-your-dental-website"
                >Best Dental Chat Bot Add to your website</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a
                target="_blank"
                href="best-dental-chatbot-marketing-online-dentist-bot-for-website-messaging"
                >DentalChat using Smart Dental Chat Bot Technology</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a target="_blank" href="oral-hygiene-corona-virus-online-dentist-chat"
                >Oral hygiene corona virus online dentist chat</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a
                target="_blank"
                href="children-teeth-information-teething-blog-kid-orthodontics-blogging-online"
                >Children Teeth Information, Teething Blog, Kid Orthodontics</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a target="_blank" href="your-local-dentist-questions-best-dental-quiz-online"
                >Test your dental knowledge - Dental Quiz:
              </a>
            </li>
            <li [hidden]="!showLink3">
              <a target="_blank" href="answers-to-best-dental-questions-online-local-dentist-quiz"
                >Answers to dental questions
              </a>
            </li>
            <li [hidden]="!showLink3">
              <a
                target="_blank"
                href="gum-disease-information-blog-periodontal-care-treatment-online"
                >Gum Disease Information, Gum Care Treatment</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a
                target="_blank"
                href="best-dental-antibiotics-information-blog-amoxicillin-dentistry-antibiotic-question-chat"
                >Dental Antibiotics used in Dentistry</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a
                target="_blank"
                href="best-local-wisdom-tooth-extraction-information-third-molar-question-info"
                >Wisdom Tooth Info, Best Third Molars Extraction Information</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a
                target="_blank"
                href="cosmetic-dental-veneers-information-teeth-whitening-dental-veneer-info-blog"
                >Cosmetic Dental Veneers Information, Teeth Whitening</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a target="_blank" href="best-pulpotomy-information-local-children-dental-caries-blog"
                >Dental Caries in Children, Pulpotomy Info</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a
                target="_blank"
                href="local-clear-aligners-information-invisalign-info-blog-orthodontic-braces-question-online"
                >Clear Aligners, Invisalign and Orthodontic Braces</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a
                target="_blank"
                href="/local-sleep-apnea-treatment-question-chat-online-sleep-info-blog"
                >Sleep Apnea Treatment Chat</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a
                target="_blank"
                href="/my-chipped-tooth-help-question-online-composite-filling-teledental-consult"
                >My Chipped Tooth Help, Composite Filling Teledental Consult</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a
                target="_blank"
                href="/local-emergency-dentist-virtual-dental-care-consultation-online"
                >Online virtual dental problem consulting</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a target="_blank" href="local-dentist-office-FAQs-tele-dental-FAQ"
                >Local Dentist Office FAQs, Tele Dental FAQ</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a
                target="_blank"
                href="best-gum-disease-question-online-teledentistry-periodontist-answers"
                >Best gum disease question & tele perio answers</a
              >
            </li>
            <li [hidden]="!showLink3">
              <a
                target="_blank"
                href="best-urgent-dentistry-questions-online-local-teledentistry-emergency-dentist-answers"
                >Urgent dentistry FAQ info, local emergency dentist help chat</a
              >
            </li>

            <li class="viewmore">
              <a (click)="showHideLinks(3)"
                ><span [hidden]="showLink3">+ More</span
                ><span [hidden]="!showLink3">- Less</span></a
              >
            </li>

            <!---------------------------------- +32 more new Rahul ----------------------------------->
          </ul>
        </div>

        <div class="col-md-4 col-sm-4 col-xs-12">
          <ul class="link-ft">
            <li>
              <a
                target="_blank"
                href="local-teledentistry-messaging-dental-chat-bot-best-dentists-chatbots-web-communication"
                >Best Dental ChatBot</a
              >
            </li>
            <li>
              <a target="_blank" href="online-dentists-chat-blog">Online Dentists Chat Blog</a>
            </li>
            <li>
              <a target="_blank" href="online-dental-communication">Online Dental Communication</a>
            </li>
            <li>
              <a target="_blank" href="online-emergency-dentist-question"
                >Online Emergency Dentist Question</a
              >
            </li>
            <li>
              <a target="_blank" href="local-emergency-dental-questions-online"
                >Local Emergency Dental Questions Online</a
              >
            </li>

            <!---------------------------------- +31 more new Rahul ----------------------------------->

            <li [hidden]="!showLink4">
              <a target="_blank" href="local-emergency-dental-chat-and-tooth-problems-blog"
                >local emergency dental chat, dental problems and dental implant problem</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a target="_blank" href="local-dental-chatting-online"
                >Dental Implant Failure, Dental Implants Information</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a target="_blank" href="root-canal-problem-chat-and-dental-pain-chatting"
                >local root canal chat, dental pain chatting</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a target="_blank" href="dental-specialties-chat-general-dentistry-chatting"
                >Dental Specialties Chat about General Dentistry</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a target="_blank" href="Things-to-know-about-dental-implants-dental-implant-info"
                >Things to know about dental implants, Dental Implant Info</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a target="_blank" href="how-to-keep-gums-healthy-gum-disease-blog"
                >How to keep gums healthy / gum disease information</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a
                target="_blank"
                href="best-dental-chat-with-dentists-connecting-patients-to-dentists-teledentistry-online"
                >Dental Chat With Dentists, Dental Messaging</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a target="_blank" href="local-dental-tele-medicine-blog-best-free-teledentistry-chat"
                >Dental Tele Medicine, Best TeleDentistry Chat</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a
                target="_blank"
                href="online-dental-consultation-with-patient-local-dental-telemedicine-chat"
                >Online Dental Consultation, Local Dental Telemedicine Chat</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a
                target="_blank"
                href="local-dentist-emergency-info-local-emergency-dentists-directory-listing-online"
                >Local Emergency Dentists, Immediate Dental Care Information</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a target="_blank" href="tooth-extraction-chat-avoiding-a-dry-socket-blog"
                >Tooth extraction chat, avoiding a dry socket blog</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a
                target="_blank"
                href="bone-graft-after-tooth-extraction-blog-local-gum-surgery-chat-online"
                >Bone graft after tooth extraction, local gum surgery chat</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a
                target="_blank"
                href="dental-chat-about-cosmetic-dentistry-treatment-and-dental-crowns"
                >Dental Chat about cosmetic dentistry, dental crowns discussion</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a target="_blank" href="tmj-jaw-pain-question-stem-cells-in-dentistry"
                >TMJ Blog, TMD Disorder Pain Treatment Question: Why Does My Jaw Hurt?</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a
                target="_blank"
                href="online-dental-insurance-chat-local-dental-insurances-question-blog"
                >Dental Insurance Blog, Dental Plan Discussion</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a
                target="_blank"
                href="dental-bone-grafting-question-chat-dental-ridge-augmentation-blog"
                >Dental Bone Grafting, Dental Ridge Augmentation</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a target="_blank" href="find-local-dentists-near-you-free-dental-consult-online"
                >Find Dentists Near You, Free Dental Consult Online</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a
                target="_blank"
                href="oral-hygiene-blog-local-dental-exam-and-dental-prophy-blogging"
                >Oral hygiene blog, dental exam and dental prophy blogging</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a
                target="_blank"
                href="clear-aligner-information-blog-orthodontic-braces-treatment-question-info"
                >Clear Aligners Information, Orthodontic Braces Info</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a target="_blank" href="dentistry-cost-usa">Dental procedure costs</a>
            </li>
            <li [hidden]="!showLink4">
              <a
                target="_blank"
                href="virtual-teledental-information-local-teledentist-dental-care-covid-info"
                >Virtual TeleDental, Local TeleDentist, Dental Care COVID Info</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a
                target="_blank"
                href="local-dental-insurance-blog-teledental-consulting-online-ai-dentistry-information"
                >Dental Insurance Blog, TeleDental Consulting Online</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a
                target="_blank"
                href="children-dentistry-information-best-kids-oral-hygiene-blog-online"
                >Children Dentistry, Best Kids Oral Hygiene</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a
                target="_blank"
                href="cleft-lip-blog-and-palate-cleft-question-chat-information-online"
                >Cleft Lip and Palate Cleft Information</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a
                target="_blank"
                href="live-dentists-on-demand-virtual-dentistry-free-local-teledentistry-online"
                >Live Dentists On Demand Virtual Dentistry, Free TeleDentistry</a
              >
            </li>
            <li [hidden]="!showLink4">
              <a
                target="_blank"
                href="white-composite-fillings-information-composite-filling-question-local-teledentist-sensitive-teeth-consult-online"
                >Composite tooth filling information, Sensitive teeth</a
              >
            </li>

            <li class="viewmore">
              <a (click)="showHideLinks(4)"
                ><span [hidden]="showLink4">+ More</span
                ><span [hidden]="!showLink4">- Less</span></a
              >
            </li>
            <!---------------------------------- +31 more new Rahul ----------------------------------->
          </ul>
        </div>

        <div class="col-md-4 col-sm-4 col-xs-12">
          <ul class="link-ft">
            <li><a target="_blank" href="dental-implant-questions">Dental Implant Questions</a></li>
            <li>
              <a target="_blank" href="online-dentists-marketing">Online Dentists Marketing</a>
            </li>
            <li>
              <a
                target="_blank"
                href="periodontitis-chatting-perio-treatment-chat-local-periodontist-blog"
                >Gum Disease, Periodontitis Chatting</a
              >
            </li>
            <li>
              <a target="_blank" href="oral-cancer-question-mouth-cancer-blog-oral-lesions-chat"
                >Mouth Cancer and Oral lesions Blog</a
              >
            </li>
            <li>
              <a target="_blank" href="dental-anxiety-blog-local-holistic-dentistry-chat"
                >Dental anxiety and holistic dentistry</a
              >
            </li>

            <!---------------------------------- +30 more new Rahul ----------------------------------->

            <li [hidden]="!showLink5">
              <a target="_blank" href="swollen-painful-gum-question-and-oral-hygiene-chat"
                >swollen painful gums question, tooth brushing and good oral hygiene chat</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a target="_blank" href="common-dental-question"
                >Common Dental Question/Emergency Dentists Questionings</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a target="_blank" href="dental-question-blogging"
                >Dental Question Blogging & Local Emergency Dentist Questions Online</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a target="_blank" href="urgent-dental-care-chat"
                >Urgent Dental Care Chat, Emergency Dentistry Questions Chatting</a
              >
            </li>
            <!-- <li><a target = "_blank" href="dental-specialties-chat-dentistry-information-online">Dental Specialties chat dentistry information online</a></li> -->
            <li [hidden]="!showLink5">
              <a target="_blank" href="teeth-whitening-questions-tooth-whitening-chat"
                >Yellow teeth chatting, teeth whitening discussion</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a
                target="_blank"
                href="periodontitis-chatting-perio-treatment-chat-local-periodontist-blog-online-periodontitis-discussion"
                >Periodontal Discussion, Local Perio Treatment Chatting, Periodontist Blog:</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a target="_blank" href="online-healthy-smile-chat-cosmetic-dental-care-blog"
                >Importance of healthy smile, cosmetic dental care blog</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a
                target="_blank"
                href="new-dentist-technology-better-dental-supplies-best-dental-machines"
                >New dentist technology, best dental machines for x-rays</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a target="_blank" href="best-local-dental-marketing-seo-find-a-emergency-dentist-now"
                >Best local dental marketing, find a dentist now</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a
                target="_blank"
                href="local-dental-problems-blog-local-dentist-treatment-solutions-chat"
                >Local Dental Problems & Dentists Treatment Solutions Chat</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a
                target="_blank"
                href="local-ai-in-dentistry-artificial-intelligence-for-dental-care-blog"
                >Local Ai in Dentistry Chat, Artificial Intelligence for Dental Care Blog</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a
                target="_blank"
                href="finding-a-local-emergency-dentist-best-dental-care-questions-discussion"
                >Finding a Local Emergency Dentist, Best Dental Care Questions Discussion</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a target="_blank" href="ask-dentist-why-bad-breath-halitosis-question-chat"
                >Having Bad Breath Questions? Ask About Halitosis Question Online</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a
                target="_blank"
                href="dental-veneers-blog-dental-veneer-question-info-dental-crown-blogging"
                >Dental veneers blog, dental veneer information</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a target="_blank" href="teeth-grinding-chat-online-bruxism-question-blog"
                >Teeth grinding chat, Bruxism discussion</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a target="_blank" href="oral-cancer-question-mouth-cancer-blog-oral-lesions-chat"
                >Mouth Cancer and Oral lesions Blog</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a
                target="_blank"
                href="best-dental-implants-placement-information-blog-about-dental-implant-question"
                >Best dental implants placement information</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a
                target="_blank"
                href="free-dental-consult-online-dentist-consultation-with-live-dental-chat"
                >Free Dental Consult Online with DentalChat</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a
                target="_blank"
                href="local-oral-surgery-blogging-about-orthognathic-surgery-treatment-question-blog"
                >Oral surgery blogging about orthognathic corrective jaw surgery</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a
                target="_blank"
                href="local-oral-surgery-information-about-wisdom-teeth-extraction-and-jaw-alignment-surgery-info-blog-site"
                >Oral surgery, wisdom teeth information and jaw alignment surgery</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a
                target="_blank"
                href="best-tmj-pain-information-blog-online-local-tmd-virtual-dental-care-question"
                >TMJ & TMD Jaw Information</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a
                target="_blank"
                href="best-dental-marketing-add-teledentistry-add-dental-chatbot-get-dental-leads"
                >Best Dental Marketing - Add Teledentistry, Add Dental ChatBot, Get Dental Leads</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a
                target="_blank"
                href="baby-teeth-questions-orthodontic-gum-problem-question-wisdom-tooth-growing-in-pain-problem-info"
                >Baby Teeth Questions, Orthodontic Gum Problem Question</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a
                target="_blank"
                href="autistic-dentistry-information-blog-and-autism-dental-care-info"
                >Autistic Dentistry and Autism Dental Care Info</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a
                target="_blank"
                href="space-maintainer-children-dental-care-early-baby-tooth-loss-dentistry-question"
                >Space Maintainers Children Dental Care, Early Baby Teeth Loss</a
              >
            </li>

            <li [hidden]="!showLink5">
              <a
                target="_blank"
                href="local-clear-aligners-treatment-chat-answering-orthodontic-braces-questions-dental-care"
                >Clear Aligner Treatment, Answering Orthodontic Braces Questions</a
              >
            </li>

            <li [hidden]="!showLink5">
              <a
                target="_blank"
                href="local-dental-insurance-coverage-blog-dental-plan-chat-local-teledentistry-consult"
                >Dental Insurance, Dental Plans and Teledentistry
              </a>
            </li>

            <li [hidden]="!showLink5">
              <a
                target="_blank"
                href="add-live-dental-chatbot-local-teledentistry-virtual-dentist-service-online"
              >
                Dental ChatBot, Add Teledentistry Service
              </a>
            </li>

            <!-- <li [hidden]="!(showLink5)"><a target = "_blank" href="best-dental-software-services-online-dentist-chatbot-service"> Best Dental Software Service Information </a></li>
              <li [hidden]="!(showLink5)"><a target = "_blank" href="best-dental-implant-questions-online-dental-implants-answers"> Dental implant questions & dental implants answers </a></li>
              <li [hidden]="!(showLink5)"><a target = "_blank" href="immediate-virtual-dentistry-online-teledentist-answers"> Immediate virtual dentistry, dental chat with teledentists </a></li> -->
            <li [hidden]="!showLink5">
              <a
                target="_blank"
                href="best-dental-crown-question-dental-veneers-answers-dental-bridge-questions-info"
                >Dental Crown, Veneers and Dental Bridge Info
              </a>
            </li>
            <li [hidden]="!showLink5">
              <a target="_blank" href="local-missing-tooth-question-dental-chat-answers-online"
                >Missing Tooth Treatment Information Online
              </a>
            </li>
            <li [hidden]="!showLink5">
              <a
                target="_blank"
                href="importance-of-teeth-cleaning-prophy-and-live-urgent-dentistry-info"
                >Importance of Teeth Cleaning Prophy and Live Urgent Dentistry Info</a
              >
            </li>
            <li [hidden]="!showLink5">
              <a
                target="_blank"
                href="best-dental-insurance-and-dental-discount-plan-information-online"
                >Best Dental Insurance and Dental Discount Plan Information Online</a
              >
            </li>

            <li class="viewmore">
              <a (click)="showHideLinks(5)"
                ><span [hidden]="showLink5">+ More</span
                ><span [hidden]="!showLink5">- Less</span></a
              >
            </li>
            <!---------------------------------- +31 more new Rahul ----------------------------------->
          </ul>
        </div>

        <!-- <div class="col-md-12 col-sm-12">
            <ul class="link-ft">
              <li><a target="_blank" href="/cosmetic-dentistry">Cosmetic Dentistry Procedures</a></li>
              <li><a target="_blank" href="/oral-pathology">Common Oral Diseases / Oral Pathology Problems</a></li>
              <li><a target="_blank" href="/sansitivity">Dental Pain from Teeth Sensitivity</a></li>
              <li><a target="_blank" href="/emergency-dentist-question">Emergency Dentist Questions</a></li>
              <li><a target="_blank" href="/emergency-dental-care-question">Emergency Dental Care Question / Ask a Local Dentist</a></li>
              <li><a target="_blank" href="/getting-braces-orthodontist-treatment-info">Getting Braces – Orthodontist Treatment Info</a></li>
              <li><a target="_blank" href="/local-dentists-communication">Local Dentists Communications</a></li>
              <li><a target="_blank" href="/local-emergency-dental-questions-online">Local Emergency Dental Questions Online</a></li>
              <li><a target="_blank" href="/online-emergency-dentist-question">Online Emergency Dentist Question</a></li>
              <li><a target="_blank" href="/local-emergency">Local Emergency Dentist Chat</a></li>
              <li><a target="_blank" href="/local-dental-chatting-online">Local Dental Implants / Dental Implant Failures</a></li>
              <li><a target="_blank" href="/local-root-canal-chat">Local root Canal Chat</a></li>
              <li><a target="_blank" href="/online-dental-communication">Online Dental Communication</a></li>
              <li><a target="_blank" href="/online-dentists-chat-blog">Online Dentists Chat Blog</a></li>
              <li><a target="_blank" href="/online-dentists-marketing">Online Dentists Marketing</a></li>
              <li><a target="_blank" href="/painful-gums">Periodontal Gum Problems</a></li>
              <li><a target="_blank" href="/dental-implant-questions">Dental Implant Questions</a></li>
              <li ><a target="_blank" href="/common-dental-question">Common Dental Question/Emergency Dentists Questionings</a></li>
              <li ><a target="_blank" href="/dental-question-blogging">Dental Question Blogging & Local Emergency Dentist Questions Online</a></li>
              <li ><a target="_blank" href="/urgent-dental-care-chat">Urgent Dental Care Chat, Emergency Dentistry Questions Chatting
              </a></li>
              <li><div class="sitelock-logo"><a href="#" onclick="window.open('https://www.sitelock.com/verify.php?site=dentalchat.com','SiteLock','width=600,height=600,left=160,top=170');" ><img class="img-responsive" alt="SiteLock" title="SiteLock" src="//shield.sitelock.com/shield/dentalchat.com" /></a></div></li>

            </ul>
          </div> -->
      </div>
    </div>
  </div>

  <div class="footer_bottom">
    <div class="container">
      <div class="row clearfix">
        <div class="col-md-7 col-sm-9 col-xs-12 clearfix">
          <ul>
            <li><a target="_blank" href="/privacy-policy">Privacy Policy </a></li>
            <li><a target="_blank" href="/terms-and-conditions">Terms and conditions</a></li>
            <li>
              <p>© Copyright {{ CurrentDate | date : 'yyyy' }} DentalChat. All rights reserved.</p>
            </li>
          </ul>
        </div>
        <div class="col-md-5 col-sm-3 col-xs-12 clearfix">
          <div class="btn-app">
            <!-- <a  href="https://play.google.com/store/apps/details?id=com.dental.chat&amp;hl=en_US" target="_blank">
                <img class="img-responsive" src="assets/images/google/google.png" alt="Google icon">
              </a> -->
            <a href="https://apps.apple.com/app/id1468091229" target="_blank">
              <img
                class="img-responsive"
                src="assets/images/google/play.png"
                alt="App store icon"
              />
            </a>
          </div>
          <div class="footer_socialBox">
            <ul>
              <li>
                <a href="https://www.facebook.com/dentalchat/" target="_blank"
                  ><i class="fa fa-facebook" aria-hidden="true"></i
                ></a>
              </li>
              <li>
                <a href="https://twitter.com/dentalchat" target="_blank"
                  ><i class="fa fa-twitter" aria-hidden="true"></i
                ></a>
              </li>
              <li>
                <a href="https://www.instagram.com/dentalchat/" target="_blank"
                  ><i class="fa fa-instagram" aria-hidden="true"></i
                ></a>
              </li>
              <li>
                <a href="https://www.youtube.com/channel/UCU4cLVgp9i-2hDvzCewiIxw" target="_blank"
                  ><i class="fa fa-youtube" aria-hidden="true"></i
                ></a>
              </li>
              <!-- <li><a href="https://plus.google.com/115274381124451985510" target="_blank"><i class="fa fa-google-plus" aria-hidden="true"></i></a></li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>

<!-- todo <script src="js/jquery.teletype.min.js"></script> -->
